import { api, publicApi, TEMP_TOKEN_KEY } from "./api";

export interface TempLink {
  uuid: string;
  postId: number;
  hasPassword: boolean;
  expiredAt: string;
  createdAt: string;
  active: boolean;
}

export interface CreateTempLinkBody {
  postId: number;
  password?: string;
  expiredAt: string;
}

export interface UpdateTempLinkBody {
    password?: string;
    expiredAt?: string;
    isActive?: boolean;
}

export interface ValidateTempLinkBody {
  uuid: string;
  password?: string;
}

export interface ValidateTempLinkResult {
  sessionToken: string;
  postId: number;
}

//======================= PUBLIC (NO AUTH) =========================

/**
 * @param uuid
 * @returns { hasPassword: boolean }
 */
export const getTempLinkMeta = async (uuid: string): Promise<{ hasPassword: boolean } | null> => {
  try {
    const { data } = await publicApi.get(`/v1/temp-link/${uuid}/meta`);
    return data.data;
  } catch (e) {
    console.log(e);
    return null;
  }
};

/**
 * @param body
 * @returns { sessionToken, postId }
 */
export const validateTempLink = async (body: ValidateTempLinkBody): Promise<ValidateTempLinkResult | null> => {
  try {
    const { data } = await publicApi.post("/v1/temp-link/validate", body);
    const result: ValidateTempLinkResult = data.data;
    sessionStorage.setItem(TEMP_TOKEN_KEY, result.sessionToken);
    return result;
  } catch (e: any) {
    const message = e?.response?.data?.message;
    throw new Error(message ?? "알 수 없는 오류가 발생했습니다.");
  }
};

//======================= FOR ADMIN =========================

/**
 * @param postId
 * @returns TempLink[]
 */
export const getTempLinkForAdmin = async (postId: number): Promise<TempLink[]> => {
  try {
    const params = { postId };
    const { data } = await api().get("/admin/temp-link", { params });
    return data.data;
  } catch (e) {
    console.log(e);
    return [];
  }
};

/**
 * @param body
 * @returns created temp link uuid string
 */
export const createTempLinkForAdmin = async (body: CreateTempLinkBody): Promise<string> => {
  try {
    const { data } = await api().post("/admin/temp-link", body);
    return data.data;
  } catch (e) {
    console.log(e);
    return "";
  }
};

/**
 * @param uuid
 * @param body
 */
export const updateTempLinkForAdmin = async (uuid: string, body: UpdateTempLinkBody): Promise<void> => {
  try {
    await api().patch(`/admin/temp-link/${uuid}`, body);
  } catch (e) {
    console.log(e);
  }
};

/**
 * @param body
 * @returns delete temp link uuid string
 */
export const deleteTempLinkForAdmin = async (uuid : string): Promise<string> => {
    try {
      const { data } = await api().delete(`/admin/temp-link/${uuid}`);
      return data.data;
    } catch (e) {
      console.log(e);
      return "";
    }
  };
  